import { Box, Text } from '@factorialco/deprecated-design-system'
import pagBrasil from 'assets/images/billing/pag-brasil.svg'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ChargebeeSubscriptionForm } from '../FullScreenStep/form'
import BankTransferFields from './_BankTransferFields'
import CreditCardFields from './_CreditCardFields'
import PaymentMethodCard from './_PaymentMethodCard'

interface Props {
  form: ChargebeeSubscriptionForm
}

const PaymentInfoSection = ({ form }: Props) => {
  const handleChangePaymentMethod = (payment_method: string) => {
    form.setValues({
      payment_method: payment_method,
    })
  }

  return (
    <Box gap="s16">
      <Box gap="s8">
        <Text.Header2 weight="semibold">
          {i18n.t('pricing_plans.billing_information.form.payment_title')}
        </Text.Header2>
        <Text.Normal color="grey800">
          {i18n.t('pricing_plans.billing_information.form.payment_description')}
        </Text.Normal>
      </Box>
      <PaymentMethodCard
        label={i18n.t('pricing_plans.billing_information.form.card')}
        icon="credit-card"
        isSelected={form.get('payment_method').value === 'card'}
        onClick={() => {
          handleChangePaymentMethod('card')
        }}
      />
      {form.get('payment_method').value === 'card' && <CreditCardFields form={form} />}
      {form.get('payment_method').value === 'bank-transfer' && <BankTransferFields form={form} />}
      {['pix', 'boleto'].includes(form.get('payment_method').value) && (
        <>
          <Box flexDirection="row" justifyContent="center" gap="s8">
            <Text.Normal>
              {i18n.t('pricing_plans.billing_information.form.secure_paymnet_with')}
            </Text.Normal>
            <img src={pagBrasil} />
          </Box>
        </>
      )}
    </Box>
  )
}
export default observer(PaymentInfoSection)
